// Angular
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns only first letter of string
 */
@Pipe({
  name: 'firstLetter',
})
export class FirstLetterPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param value
   */
  transform(value: any): any {
    return value
      .split(' ')
      .map((n) => n[0])
      .join('');
  }
}
